/* eslint-disable global-require */
import Vue from 'vue';
import UserConstants from '../../constants/column-name/user.column-name.constants';
import AddEditMixin from '../shared/AddEditMixin';
import AddEditForm from '../shared/AddEditForm';
import FormDataService from '../../../services/form-data.service';
import UserFormConstants from '../../constants/form/user.form.constants';
import Mappings from './UserAutoCompleteMaps';

export default Vue.component('window', {
  beforeCreate() {
    this.$options.components.AutoComplete = require('../shared/AutoComplete.vue').default;
    this.$options.components.CustomerAutoComplete = require('../customer/CustomerAutoComplete.vue').default;
  },
  template: `<AddEditForm title='${UserFormConstants.FormTitle}' ref="addEditForm" @submit-button-clicked="onFormSubmit">
    ${FormDataService.textInput(UserConstants.username)}
    ${FormDataService.textInput({
      field: 'password',
      required: true,
      label: 'Password',
      type: 'password'
    })}
    ${FormDataService.textInput(UserConstants.email)}
    <CustomerAutoComplete :formData="formData" :mapping="mappings.Customer" />
    <div class="form-field form-checkbox">
      <AutoComplete
        :formData="formData"
        :clearRightPadding="true"
        openDirection="above"
        :mapping="mappings.ThirdParty"
        store="ThirdParty"
        placeholder="Select Third Party"
        :allowAdditions="true"
      >Third Party </AutoComplete>
      <div class="add-role-access form-group">
        ${FormDataService.checkboxInput(UserConstants.hasAdministratorAccess)}
        ${FormDataService.checkboxInput(UserConstants.hasGlobalAccess)}
        ${FormDataService.checkboxInput(UserConstants.hasThirdPartyAccess)}
      </div>
    </div>
  </AddEditForm>`,
  name: UserFormConstants.FormName,
  data() {
    return {
      formData: {},
      defaultPassword: '*********',
      mappings: Mappings
    };
  },
  mixins: [AddEditMixin],
  methods: {
    checkForm(isEdit) {
      const errors = this.checkFormSubmission(UserConstants);
      if (!this.validEmail(this.formData.email) && !isEdit && this.formData.email !== '') {
        errors.push('Valid email required.');
      }
      return errors;
    },
    onRoleSelect(e) {
      this.hasGlobalAccess = false;
      this.hasThirdPartyAccess = false;
      if (e.dataItem.text === 'Global') {
        this.hasGlobalAccess = true;
      } else if (e.dataItem.text === 'Third Party' && this.formData.thirdParty !== '') {
        this.hasThirdPartyAccess = true;
      }
    }
  },
  components: { AddEditForm }
});
